"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2560],{

/***/ 5049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ TabIconButton; },
/* harmony export */   "Y": function() { return /* binding */ TabButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17573);
/* harmony import */ var src_components_common_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78296);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73098);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68251);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            font-weight: 700;\n            color: ",
        " !important;\n            border-color: ",
        " !important;\n            b,\n            strong {\n              font-weight: 700;\n            }\n          "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            font-weight: 300;\n            color: ",
        ";\n            b,\n            strong {\n              font-weight: 300;\n            }\n          "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  && {\n    display: flex;\n    align-items: center;\n\n    min-width: min-content;\n    min-height: 26px;\n\n    font-size: 13px;\n    line-height: 21px;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    white-space: nowrap;\n\n    transition: all 0.2s ease;\n\n    color: ",
        ";\n    border-bottom: 1rpx solid\n      ",
        ";\n\n    ",
        " {\n      font-size: 14px;\n      padding-bottom: 6px;\n    }\n\n    br {\n      display: none;\n    }\n\n    &:hover,\n    &:focus {\n      color: ",
        ";\n      border-color: currentColor;\n    }\n\n    ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  && {\n    min-width: 24px;\n    justify-content: center;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var TabButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(src_components_common_Button__WEBPACK_IMPORTED_MODULE_1__/* .CleanButton */ .ux).withConfig({
    displayName: "TabButton",
    componentId: "sc-71a4751e-0"
})(_templateObject2(), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .fromTheme */ .HW)(function(theme) {
    return theme.text.palette.primary;
}), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .fromTheme */ .HW)(function(theme) {
    return (0,polished__WEBPACK_IMPORTED_MODULE_5__/* .transparentize */ .DZ)(0.6, theme.text.palette.primary);
}), src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .fromTheme */ .HW)(function(theme) {
    return theme.text.palette.accent;
}), function(param) {
    var $active = param.$active;
    return $active ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__.css)(_templateObject(), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .fromTheme */ .HW)(function(theme) {
        return theme.text.palette.accent;
    }), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .fromTheme */ .HW)(function(theme) {
        return theme.text.palette.accent;
    })) : (0,styled_components__WEBPACK_IMPORTED_MODULE_4__.css)(_templateObject1(), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .fromTheme */ .HW)(function(theme) {
        return theme.text.palette.heavy;
    }));
});
var TabIconButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(TabButton).withConfig({
    displayName: "TabButton__TabIconButton",
    componentId: "sc-71a4751e-1"
})(_templateObject3());


/***/ }),

/***/ 16001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ ScrollToSectionOnClick; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_providers_LayoutRegisterProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63085);
/* harmony import */ var src_components_common_ResponsiveUnit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47631);







var ScrollToSectionOnClick = function(_param) {
    var children = _param.children, id = _param.id, _offset = _param.offset, offset = _offset === void 0 ? 0 : _offset, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "id",
        "offset"
    ]);
    var ref;
    var layoutRegisterContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(src_providers_LayoutRegisterProvider__WEBPACK_IMPORTED_MODULE_2__/* .LayoutRegisterContext */ .D);
    var scrollToSection = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(px) {
        var section = document === null || document === void 0 ? void 0 : document.querySelector("#".concat(id));
        if (section != null) {
            var ref;
            var _fixed;
            window.scrollTo({
                top: section.getBoundingClientRect().top + window.scrollY - offset * px - ((_fixed = (ref = layoutRegisterContext === null || layoutRegisterContext === void 0 ? void 0 : layoutRegisterContext.ui.height) === null || ref === void 0 ? void 0 : ref.header.fixed) !== null && _fixed !== void 0 ? _fixed : 0) * px,
                behavior: "smooth"
            });
        }
    }, [
        id,
        offset,
        (ref = layoutRegisterContext === null || layoutRegisterContext === void 0 ? void 0 : layoutRegisterContext.ui.height) === null || ref === void 0 ? void 0 : ref.header.fixed
    ]);
    var clickCallback = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e, px) {
        var _props, ref, ref1;
        (ref = (_props = children.props).onClick) === null || ref === void 0 ? void 0 : ref.call(_props, e);
        (ref1 = props.onClick) === null || ref1 === void 0 ? void 0 : ref1.call(props, e);
        scrollToSection(px);
    }, [
        children.props,
        props,
        scrollToSection
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_common_ResponsiveUnit__WEBPACK_IMPORTED_MODULE_3__/* .ResponsiveUnit */ .D, {
        children: function(px) {
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(children, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
                onClick: function(e) {
                    return clickCallback(e, px);
                }
            }));
        }
    });
};


/***/ }),

/***/ 95175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ StickyMenuProvider; },
/* harmony export */   "W": function() { return /* binding */ StickyMenuContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36305);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var rambda__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49713);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);





var StickyMenuContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)({
    activeSection: null,
    registeredSections: [],
    registerSection: function() {
        return null;
    },
    handleActiveSectionChange: function() {
        return null;
    }
});
var StickyMenuProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), registeredSections = ref[0], setRegisteredSections = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), activeSection = ref1[0], setActiveSection = ref1[1];
    var _index, _index1;
    var registerSection = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(section) {
        return setRegisteredSections(function(state) {
            return (0,rambda__WEBPACK_IMPORTED_MODULE_3__.sort)(function(a, b) {
                return ((_index = a.index) !== null && _index !== void 0 ? _index : 0) > ((_index1 = b.index) !== null && _index1 !== void 0 ? _index1 : 0) ? 1 : 0;
            }, (0,lodash__WEBPACK_IMPORTED_MODULE_1__.uniqBy)((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(state).concat([
                section
            ]), function(s) {
                return s.id;
            }));
        });
    }, [
        setRegisteredSections
    ]);
    var handleActiveSectionChange = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(value) {
        setActiveSection(value);
    }, [
        setActiveSection
    ]);
    var value = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return {
            activeSection: activeSection,
            registeredSections: registeredSections,
            registerSection: registerSection,
            handleActiveSectionChange: handleActiveSectionChange
        };
    }, [
        activeSection,
        registeredSections,
        handleActiveSectionChange,
        registerSection, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StickyMenuContext.Provider, {
        value: value,
        children: children
    });
};


/***/ }),

/***/ 25196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ StickyMenu; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(36305);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87379);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73098);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68251);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(17573);
/* harmony import */ var vendor_mods_styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10395);
/* harmony import */ var src_hooks_useRectMeasure__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48101);
/* harmony import */ var src_hooks_useWindowScroll__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87802);
/* harmony import */ var src_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(10763);
/* harmony import */ var src_components_common_TabsSwiper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2277);
/* harmony import */ var src_components_common_StickyMenu_StickyMenuContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95175);
/* harmony import */ var src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12732);






function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      right: calc(var(--scrollbar-padding) / 2);\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .sticky-menu__navbar {\n      background: rgba(255, 255, 255, 0.85);\n    }\n    ",
        " {\n      .sticky-menu__navbar {\n        background: ",
        ";\n      }\n      .sticky-menu__button {\n        color: ",
        ";\n        border-color: ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    backdrop-filter: blur(0px) !important;\n    .sticky-menu__navbar {\n      background: transparent !important;\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: ",
        ";\n  top: calc(var(--header-fixed-height));\n\n  ",
        ";\n\n  display: flex;\n  justify-content: center;\n\n  width: 100%;\n  z-index: 10;\n\n  backdrop-filter: blur(8rpx);\n  transform: translate3d(0, 0, 0);\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  padding-top: 8px;\n  padding-bottom: 9px;\n  background: transparent;\n  transition: 0.25s;\n  height: ",
        "px;\n\n  ",
        " {\n    padding-top: 11px;\n    padding-bottom: 13px;\n    height: ",
        "px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: ",
        "px;\n  ",
        " {\n    height: ",
        "px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}













var height = {
    mobile: 42,
    desktop: 52
};
var Container = styled_components__WEBPACK_IMPORTED_MODULE_11__["default"].div.withConfig({
    displayName: "StickyMenu__Container",
    componentId: "sc-1526bfc7-0"
})(_templateObject3(), function(param) {
    var $fixed = param.$fixed;
    return $fixed ? "fixed" : "sticky";
}, function(param) {
    var $fixed = param.$fixed;
    return $fixed && (0,styled_components__WEBPACK_IMPORTED_MODULE_11__.css)(_templateObject());
}, (0,src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_10__/* .casePathEmptyString */ .Q)("$passedBanner")((0,styled_components__WEBPACK_IMPORTED_MODULE_11__.css)(_templateObject1(), src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.lessThan.desktop */ .BC.w.lessThan.desktop, (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .fromTheme */ .HW)(function(theme) {
    return (0,polished__WEBPACK_IMPORTED_MODULE_12__/* .transparentize */ .DZ)(0.15, theme.palette.background);
}), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .fromTheme */ .HW)(function(theme) {
    return theme.text.palette.heavy;
}), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .fromTheme */ .HW)(function(theme) {
    return (0,polished__WEBPACK_IMPORTED_MODULE_12__/* .transparentize */ .DZ)(0.15, theme.text.palette.heavy);
}))), (0,src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_10__/* .casePathEmptyString */ .Q)("$transparent")((0,styled_components__WEBPACK_IMPORTED_MODULE_11__.css)(_templateObject2())));
var Navbar = styled_components__WEBPACK_IMPORTED_MODULE_11__["default"].div.withConfig({
    displayName: "StickyMenu__Navbar",
    componentId: "sc-1526bfc7-1"
})(_templateObject4(), height.mobile, src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, height.desktop);
var FixedNavbarSpaceReservation = styled_components__WEBPACK_IMPORTED_MODULE_11__["default"].div.withConfig({
    displayName: "StickyMenu__FixedNavbarSpaceReservation",
    componentId: "sc-1526bfc7-2"
})(_templateObject5(), height.mobile, src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, height.desktop);
var StickyMenu = function(_param) {
    var _tabs = _param.tabs, tabs = _tabs === void 0 ? [] : _tabs, theme = _param.theme, activeTab = _param.activeTab, bannerHeight = _param.bannerHeight, transparentOnTop = _param.transparentOnTop, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_param, [
        "tabs",
        "theme",
        "activeTab",
        "bannerHeight",
        "transparentOnTop"
    ]);
    var y = (0,src_hooks_useWindowScroll__WEBPACK_IMPORTED_MODULE_7__/* .useWindowScroll */ .b)().y;
    var isDesktop = (0,src_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_14__/* .useMediaQuery */ .a)(src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, true);
    var ctx = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(src_components_common_StickyMenu_StickyMenuContext__WEBPACK_IMPORTED_MODULE_9__/* .StickyMenuContext */ .W);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,src_hooks_useRectMeasure__WEBPACK_IMPORTED_MODULE_6__/* .useRectMeasure */ .R)(isDesktop ? height.desktop : height.mobile), 2), containerRef = ref[0], navHeight = ref[1];
    var passedBanner = bannerHeight == null || y >= bannerHeight - navHeight;
    var isFixed = !bannerHeight ? false : y > navHeight;
    var allTabs = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(tabs).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(ctx.registeredSections));
    if (allTabs.length < 2) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(vendor_mods_styled_components__WEBPACK_IMPORTED_MODULE_5__/* .Theme */ .Q, {
        theme: theme || (passedBanner ? src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .defaultTheme */ .uH : src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .redTheme */ .MN),
        children: [
            isFixed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FixedNavbarSpaceReservation, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, props), {
                ref: containerRef,
                $fixed: isFixed,
                $passedBanner: passedBanner,
                $transparent: transparentOnTop ? y === 0 : false,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Navbar, {
                    className: "sticky-menu__navbar",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_TabsSwiper__WEBPACK_IMPORTED_MODULE_8__/* .TabsSwiper */ .T, {
                        tabs: allTabs,
                        activeTab: activeTab !== null && activeTab !== void 0 ? activeTab : ctx.activeSection,
                        buttonClassName: "sticky-menu__button"
                    })
                })
            }))
        ]
    });
};


/***/ }),

/***/ 2277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ TabsSwiper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87379);
/* harmony import */ var src_components_TrackedLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79017);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72873);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17739);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react_t7e__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var src_components_common_ScrollToSectionOnClick__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16001);
/* harmony import */ var src_components_common_Button_TabButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5049);
/* harmony import */ var src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71008);
/* harmony import */ var vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15201);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .swiper-slide {\n    min-width: min-content;\n    width: auto;\n  }\n  .swiper-wrapper {\n    gap: 20px;\n    max-width: max-content;\n    margin: 0 auto;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var SwiperContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__["default"])(src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_7__/* .ConstraintContainer */ .a).withConfig({
    displayName: "TabsSwiper__SwiperContainer",
    componentId: "sc-69bd32eb-0"
})(_templateObject());
var TabsSwiperComponent = function(param) {
    var tabs = param.tabs, activeTab = param.activeTab, scrollOffset = param.scrollOffset, buttonClassName = param.buttonClassName, setActiveTab = param.setActiveTab;
    var _ = (0,react_t7e__WEBPACK_IMPORTED_MODULE_10__.useTranslate)()._;
    var swiperRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (swiperRef.current) {
            var ref;
            (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slideTo(tabs.findIndex(function(param) {
                var id = param.id;
                return id === activeTab;
            }));
        }
    }, [
        tabs,
        activeTab
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SwiperContainer, {
        as: swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .Swiper */ .t,
        slidesPerView: "auto",
        threshold: 10,
        onSwiper: function(swiper) {
            return swiperRef.current = swiper;
        },
        children: tabs.map(function(tab) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .SwiperSlide */ .o, {
                children: tab.link ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_TrackedLink__WEBPACK_IMPORTED_MODULE_2__/* .TrackedLink */ .A, {
                    href: tab.link,
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_Button_TabButton__WEBPACK_IMPORTED_MODULE_6__/* .TabButton */ .Y, {
                        className: buttonClassName,
                        as: "a",
                        $active: activeTab === tab.id,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_8__/* .Markdown */ .U, {
                            children: _(tab.label)
                        })
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_ScrollToSectionOnClick__WEBPACK_IMPORTED_MODULE_5__/* .ScrollToSectionOnClick */ .d, {
                    id: tab.id,
                    offset: scrollOffset,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_Button_TabButton__WEBPACK_IMPORTED_MODULE_6__/* .TabButton */ .Y, {
                        $active: activeTab === tab.id,
                        className: buttonClassName,
                        onClick: function() {
                            return setActiveTab === null || setActiveTab === void 0 ? void 0 : setActiveTab(tab.id);
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_8__/* .Markdown */ .U, {
                            children: _(tab.label)
                        })
                    })
                })
            }, tab.id);
        })
    });
};
var TabsSwiper = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.memo)(TabsSwiperComponent);


/***/ }),

/***/ 44795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ AddIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _summer_jst_react_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55537);





var AddIcon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_summer_jst_react_icon__WEBPACK_IMPORTED_MODULE_2__/* .IconBox */ .zb, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M29 2h6v60h-6z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M62 29v6H2v-6z"
            })
        ]
    }));
};


/***/ }),

/***/ 89080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ MetaDescription; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



function MetaDescription(props) {
    var description = props.children;
    return description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }, "description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:description",
                content: description
            }, "og:description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:description",
                content: description
            }, "twitter:description")
        ]
    }) : null;
}


/***/ }),

/***/ 44558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ EventCountdown; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_countdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98130);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(78420);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87379);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68251);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17739);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react_t7e__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73098);
/* harmony import */ var _summer_jst_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72559);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n  align-items: center;\n  justify-content: start;\n\n  margin-top: 36px;\n  grid-gap: 20px;\n  grid-template-areas: 'title values';\n  ",
        " {\n    position: absolute;\n    bottom: 25%;\n    right: var(--constraint-container-right-inner-margin);\n    transform: translateY(-25%);\n\n    display: grid;\n    ",
        " {\n      right: auto;\n      left: var(--constraint-container-left-inner-margin);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  grid-area: title;\n  font-style: normal;\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 1.5;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  grid-area: values;\n  display: grid;\n  grid-template-columns: auto auto auto;\n  grid-gap: 12px;\n\n  ",
        " {\n    grid-gap: 16px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 2rpx solid ",
        ";\n  color: ",
        ";\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  width: 60px;\n  height: 60px;\n\n  ",
        " {\n    width: 70px;\n    height: 70px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-style: normal;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 1.5;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-style: normal;\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 1.5;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}









var Container = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({
    displayName: "EventCountdown__Container",
    componentId: "sc-38df414b-0"
})(_templateObject(), src_styles_designs__WEBPACK_IMPORTED_MODULE_5__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .dirRTL */ .gX);
var Title = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].span.withConfig({
    displayName: "EventCountdown__Title",
    componentId: "sc-38df414b-1"
})(_templateObject1());
var Values = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({
    displayName: "EventCountdown__Values",
    componentId: "sc-38df414b-2"
})(_templateObject2(), src_styles_designs__WEBPACK_IMPORTED_MODULE_5__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var ValueRect = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({
    displayName: "EventCountdown__ValueRect",
    componentId: "sc-38df414b-3"
})(_templateObject3(), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .fromTheme */ .HW)(function(a) {
    return a.text.palette.primary;
}), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .fromTheme */ .HW)(function(a) {
    return a.text.palette.primary;
}), src_styles_designs__WEBPACK_IMPORTED_MODULE_5__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var Value = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].span.withConfig({
    displayName: "EventCountdown__Value",
    componentId: "sc-38df414b-4"
})(_templateObject4());
var Label = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].span.withConfig({
    displayName: "EventCountdown__Label",
    componentId: "sc-38df414b-5"
})(_templateObject5());
var EventCountdown = function(_param) {
    var event = _param.event, onComplete = _param.onComplete, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "event",
        "onComplete"
    ]);
    var isReady = (0,_summer_jst_react__WEBPACK_IMPORTED_MODULE_6__/* .useClientReady */ .t0)();
    var _ = (0,react_t7e__WEBPACK_IMPORTED_MODULE_9__.useTranslate)()._;
    var startDate = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return (0,date_fns__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(event.startDate);
    }, [
        event
    ]);
    var countdownRenderer = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(param) {
        var days = param.days, hours = param.hours, minutes = param.minutes, seconds = param.seconds, completed = param.completed;
        if (days >= 14 || completed) {
            return null;
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, props), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Title, {
                    children: _("Starts in")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Values, {
                    children: [
                        days >= 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ValueRect, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Value, {
                                    children: days
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Label, {
                                    children: _("days")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ValueRect, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Value, {
                                    children: hours
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Label, {
                                    children: _("hours")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ValueRect, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Value, {
                                    children: minutes
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Label, {
                                    children: _("min")
                                })
                            ]
                        }),
                        days < 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ValueRect, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Value, {
                                    children: seconds
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Label, {
                                    children: _("sec")
                                })
                            ]
                        })
                    ]
                })
            ]
        }));
    }, [
        _,
        props
    ]);
    if (!isReady) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_countdown__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
        date: startDate,
        renderer: countdownRenderer,
        onComplete: onComplete
    });
};


/***/ }),

/***/ 46855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ UserEventsEventButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17739);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react_t7e__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var src_components_common_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78296);
/* harmony import */ var src_components_icons_AddIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44795);
/* harmony import */ var src_components_icons_Close__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34039);
/* harmony import */ var src_modules_events_hooks_useUserEvents__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74224);
/* harmony import */ var src_components_common_Button_withAnimationController__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33572);











var UserEventsEventButton = function(_param) {
    var event = _param.event, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "event"
    ]);
    var _ = (0,react_t7e__WEBPACK_IMPORTED_MODULE_7__.useTranslate)()._;
    var ref = (0,src_modules_events_hooks_useUserEvents__WEBPACK_IMPORTED_MODULE_5__/* .useUserEvents */ .f)(), add = ref.add, remove = ref.remove, checkUserEnrollment = ref.checkUserEnrollment, enabled = ref.enabled;
    var isAddedToEvents = checkUserEnrollment(event.id);
    var animationControllerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var onClick = (0,src_components_common_Button_withAnimationController__WEBPACK_IMPORTED_MODULE_8__/* .withAnimationController */ .h)(animationControllerRef, function() {
        return isAddedToEvents ? remove(event.id) : add(event.id);
    });
    if (!enabled) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_common_Button__WEBPACK_IMPORTED_MODULE_2__/* .FullWidthButton */ .Ow, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
        icon: isAddedToEvents ? src_components_icons_Close__WEBPACK_IMPORTED_MODULE_4__/* .Close */ .x : src_components_icons_AddIcon__WEBPACK_IMPORTED_MODULE_3__/* .AddIcon */ .d,
        iconProps: {
            position: "right",
            size: 12
        },
        onClick: onClick,
        stateControllerRef: animationControllerRef
    }, props), {
        children: isAddedToEvents ? _("Remove from my events") : _("Add to my events")
    }));
};


/***/ }),

/***/ 67062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ eventsGqlFragment; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var src_utils_gql_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72493);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment events on events {\n    id\n    slug\n    form\n    reach\n    startDate\n    endDate\n    background\n    pastCtaLink\n    upcomingCtaLink\n    mailchimpTag\n    logo {\n      id\n    }\n    image {\n      id\n    }\n    translations {\n      howToParticipate\n      upcomingCtaLabel\n      description\n      excerpt\n      name\n      languages_code {\n        code\n      }\n    }\n    tags {\n      tags_id {\n        id\n        slug\n        translations {\n          name\n          languages_code {\n            code\n          }\n        }\n      }\n    }\n    type {\n      id\n      background\n      image {\n        id\n      }\n      logo {\n        id\n      }\n      translations {\n        description\n        excerpt\n        name\n        languages_code {\n          code\n        }\n      }\n      tags {\n        tags_id {\n          id\n          slug\n          translations {\n            name\n            languages_code {\n              code\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var eventsGqlFragment = (0,src_utils_gql_query__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());


/***/ }),

/***/ 56760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ fetchEventsList; }
});

// UNUSED EXPORTS: useEventsListQuery

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/models/query.ts
var query = __webpack_require__(19162);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/modules/events/graphql/events.fragment.ts
var events_fragment = __webpack_require__(67062);
// EXTERNAL MODULE: ./src/utils/gql/query.ts
var gql_query = __webpack_require__(72493);
;// CONCATENATED MODULE: ./src/modules/events/graphql/events-list.query.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  query EventsList($filters: events_filter, $sort: [String]) {\n    events(filter: $filters, sort: $sort, limit: -1) {\n      ...events\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var eventsListGqlQuery = (0,gql_query/* gql */.Ps)(_templateObject(), events_fragment/* eventsGqlFragment */.g);

// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/hooks/useAPIs.ts
var hooks_useAPIs = __webpack_require__(53100);
;// CONCATENATED MODULE: ./src/modules/events/hooks/useEventsListQuery.ts







var fetchEventsList = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(apis, variables) {
        var directus;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        apis.directus()
                    ];
                case 1:
                    directus = _state.sent();
                    return [
                        2,
                        directus.query(eventsListGqlQuery, (0,_object_spread/* default */.Z)({
                            sort: [
                                "sort"
                            ]
                        }, variables)).then(function(a) {
                            return a.events;
                        })
                    ];
            }
        });
    });
    return function fetchEventsList(apis, variables) {
        return _ref.apply(this, arguments);
    };
}();
var useEventsListQuery = function() {
    var apis = useAPIs();
    return useQuery(QueryKey.EventsList, function() {
        return fetchEventsList(apis);
    });
};


/***/ }),

/***/ 73082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useFlattenEvent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_hooks_directus_useTranslateItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70057);




var useFlattenEvent = function(event) {
    var translateFn = (0,src_hooks_directus_useTranslateItem__WEBPACK_IMPORTED_MODULE_1__/* .useTranslateItem */ .L)();
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var ref, ref1, ref2;
        var translatedEvent = translateFn(event);
        var translatedEventType = event.type != null ? translateFn(event.type) : null;
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, translatedEventType, translatedEvent), {
            id: translatedEvent.id,
            name: translatedEvent.name,
            description: translatedEvent.description || (translatedEventType === null || translatedEventType === void 0 ? void 0 : translatedEventType.description) || "",
            excerpt: translatedEvent.excerpt || (translatedEventType === null || translatedEventType === void 0 ? void 0 : translatedEventType.excerpt) || "",
            type: translatedEventType,
            tags: (((ref = event.tags) === null || ref === void 0 ? void 0 : ref.length) > 0 ? event.tags : ((ref1 = event.type) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.tags) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 ? event.type.tags : []).map(function(a) {
                return translateFn(a.tags_id);
            })
        });
    }, [
        event,
        translateFn
    ]);
};


/***/ }),

/***/ 80141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ useIsMultidayEvent; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78420);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3151);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49160);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var useIsMultidayEvent = function(event) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var startDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(event.startDate);
        var endDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(event.endDate);
        return [
            !(0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(startDate, endDate),
            !(0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(startDate, endDate)
        ];
    }, [
        event
    ]), isMultiDayEvent = ref[0], displayStartDateMonth = ref[1];
    return {
        isMultiDayEvent: isMultiDayEvent,
        displayStartDateMonth: displayStartDateMonth
    };
};


/***/ }),

/***/ 74224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ useUserEvents; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/hooks/useAPIs.ts
var useAPIs = __webpack_require__(53100);
// EXTERNAL MODULE: ./src/models/query.ts
var query = __webpack_require__(19162);
;// CONCATENATED MODULE: ./src/modules/events/hooks/useAddUserEventMutation.ts





var useAddUserEventMutation = function() {
    var apis = (0,useAPIs/* useAPIs */.V)();
    var queryClient = (0,es.useQueryClient)();
    return (0,es.useMutation)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(eventId) {
            var directus;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            apis.directus()
                        ];
                    case 1:
                        directus = _state.sent();
                        return [
                            2,
                            directus.api.userEvents.add(eventId)
                        ];
                }
            });
        });
        return function(eventId) {
            return _ref.apply(this, arguments);
        };
    }(), {
        onSuccess: function() {
            queryClient.invalidateQueries(query/* QueryKey.UserEvents */.S.UserEvents);
        }
    });
};

;// CONCATENATED MODULE: ./src/modules/events/hooks/useRemoveUserEventMutation.ts





var useRemoveUserEventMutation = function() {
    var apis = (0,useAPIs/* useAPIs */.V)();
    var queryClient = (0,es.useQueryClient)();
    return (0,es.useMutation)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(eventId) {
            var directus;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            apis.directus()
                        ];
                    case 1:
                        directus = _state.sent();
                        return [
                            2,
                            directus.api.userEvents.remove(eventId)
                        ];
                }
            });
        });
        return function(eventId) {
            return _ref.apply(this, arguments);
        };
    }(), {
        onSuccess: function() {
            queryClient.invalidateQueries(query/* QueryKey.UserEvents */.S.UserEvents);
        }
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/modules/user/hooks/useUserQuery.ts
var useUserQuery = __webpack_require__(44320);
// EXTERNAL MODULE: ./src/modules/events/hooks/useEventsListQuery.ts + 1 modules
var useEventsListQuery = __webpack_require__(56760);
// EXTERNAL MODULE: ./src/utils/queryCommonOptions.tsx
var queryCommonOptions = __webpack_require__(57750);
;// CONCATENATED MODULE: ./src/modules/events/hooks/useUserEventsListQuery.ts










var fetchUserEventsList = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(apis) {
        var directus, eventIds;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        apis.directus()
                    ];
                case 1:
                    directus = _state.sent();
                    return [
                        4,
                        directus.api.userEvents.list()
                    ];
                case 2:
                    eventIds = _state.sent();
                    if (!eventIds || eventIds.length === 0) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        2,
                        (0,useEventsListQuery/* fetchEventsList */.l)(apis, {
                            filters: {
                                id: {
                                    _in: eventIds
                                }
                            }
                        })
                    ];
            }
        });
    });
    return function fetchUserEventsList(apis) {
        return _ref.apply(this, arguments);
    };
}();
var userEventsListQuery = function(apis, enabled) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queryCommonOptions/* queryCommonOptions.commonHandlers */.e.commonHandlers, queryCommonOptions/* queryCommonOptions.longStale */.e.longStale), {
        queryKey: query/* QueryKey.UserEvents */.S.UserEvents,
        queryFn: function() {
            return fetchUserEventsList(apis);
        },
        enabled: enabled
    });
};
var useUserEventsListQuery = function() {
    var apis = (0,useAPIs/* useAPIs */.V)();
    var user = (0,useUserQuery/* useUserQuery */.b)();
    return (0,es.useQuery)(userEventsListQuery(apis, !!user.data));
};

// EXTERNAL MODULE: ./src/utils/reactQuery.tsx
var reactQuery = __webpack_require__(4766);
;// CONCATENATED MODULE: ./src/modules/events/hooks/useUserEvents.ts




var useUserEvents = function() {
    var userEventsQuery = useUserEventsListQuery();
    var addUserEventMutation = useAddUserEventMutation();
    var removeUserEventMutation = useRemoveUserEventMutation();
    return {
        isLoading: (0,reactQuery/* anyQueryIsLoading */.LW)(userEventsQuery, addUserEventMutation, removeUserEventMutation),
        events: userEventsQuery.data,
        enabled: !!userEventsQuery.data,
        add: addUserEventMutation.mutateAsync,
        remove: removeUserEventMutation.mutateAsync,
        checkUserEnrollment: function(eventId) {
            var ref;
            return (ref = userEventsQuery.data) === null || ref === void 0 ? void 0 : ref.some(function(e) {
                return e.id === eventId;
            });
        }
    };
};


/***/ })

}]);